import { useTranslation } from 'react-i18next';

export default function ServicePage() {
  const { t } = useTranslation();

  return (
    <div className="page">
      <div className="page-header">
        <h1 className="page-title">
          <i className="fa fa-cogs" /> {t('Service', 'Service')}
        </h1>
      </div>
      <div className="form-card">
        <div className="empty-state">
          <i className="fa fa-cogs" style={{ fontSize: 48, marginBottom: 12, display: 'block', color: 'var(--mod-service)' }} />
          <p>Service module — manage service items and billing.</p>
          <p className="text-muted">Coming soon</p>
        </div>
      </div>
    </div>
  );
}
